module.exports = __webpack_public_path__ + "static/media/lowry.defb7018.jpg";